import { useEffect } from 'react';

export default function HeadMeta({ title, description }) {
  useEffect(() => {
    // Page Title
    if (title) {
      document.title = title === 'Captain Hurghada Tours' ? title : `${title} - Captain Hurghada Tours`;
    } else {
      document.title = 'Captain Hurghada Tours';
    }

    // Meta Description
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);
    }
  }, [title, description]);

  return null;
}
